import SendCommon from "../SendCommon";

function SendOptions({ isSend, setIsSend }) {
  return (
    <SendCommon
      isSendModalOpen={isSend}
      setIsSendModalOpen={setIsSend}
      directionToOpen="up"
      customClass="send-options-modal-container"
      isFromBrowser={true}
    />
  );
}

export default SendOptions;
